const ITEMS = [
  "EST. 1935",
  "KNOWLEDGE OUR LIGHT",
  "CHANDBAGH, DEHRADUN",
  "91ST FOUNDER'S DAY",
  "OCTOBER 22–24, 2026",
  "LEGACY & LEADERSHIP",
];

export default function Marquee() {
  const row = ITEMS.map((t, i) => (
    <span key={i} className="mx-5 inline-flex items-center gap-10">
      <span className="font-display text-sm tracking-[0.3em] text-gold/80 marquee-item">{t}</span>
      <span className="text-gold/40">✦</span>
    </span>
  ));
  return (
    <div className="relative overflow-hidden border-y border-line/15 bg-panel/40 py-4" data-testid="marquee-band">
      <div className="marquee-track flex w-max" style={{ "--marquee-dur": "48s" }}>
        <div className="flex">{row}</div>
        <div className="flex" aria-hidden="true">{row}</div>
      </div>
    </div>
  );
}
